export class NavMenuItem {
  title: string;
  path: string;
  disabled: boolean;
  isExternal: boolean = false;
  children?: NavMenuItem[];
  mouseOverDescription: string;

  constructor(
    title: string,
    path: string,
    disabled: boolean,
    children?: NavMenuItem[],
    mouseOverDescp?: string
  ) {
    this.title = title;
    this.path = path;
    this.disabled = disabled;
    this.isExternal = path.startsWith('//');
    this.children = children;
    if (mouseOverDescp != null) this.mouseOverDescription = mouseOverDescp;
    else this.mouseOverDescription = '';
  }
}
